var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "modal-header" },
        [
          _c("h4", { staticClass: "modal-title" }, [_vm._v("Update Order")]),
          _c(
            "md-button",
            {
              staticClass:
                "md-simple md-just-icon md-round modal-default-button",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$modal.hide($event)
                },
              },
            },
            [_c("md-icon", [_vm._v("clear")])],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          !_vm.isLoading
            ? _c(
                "form-wrapper",
                {
                  staticClass: "form-wrapper",
                  attrs: { validator: _vm.$v.orderDetails },
                },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "name", label: "Shipping Contact Name" } },
                    [
                      _c("md-input", {
                        model: {
                          value: _vm.orderDetails.contact.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.orderDetails.contact, "name", $$v)
                          },
                          expression: "orderDetails.contact.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "form-group",
                    {
                      attrs: { name: "phone", label: "Shipping Contact Phone" },
                    },
                    [
                      _c("md-input", {
                        model: {
                          value: _vm.orderDetails.contact.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.orderDetails.contact, "phone", $$v)
                          },
                          expression: "orderDetails.contact.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "form-group",
                    {
                      attrs: { name: "email", label: "Shipping Contact Email" },
                    },
                    [
                      _c("md-input", {
                        model: {
                          value: _vm.orderDetails.contact.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.orderDetails.contact, "email", $$v)
                          },
                          expression: "orderDetails.contact.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("google-autocomplete", {
                        attrs: {
                          label: "Shipping Address",
                          id: "autoaddress",
                          classname: "form-control autocomplete-input",
                          placeholder: "",
                          "should-focus": false,
                          name: "shippingAddress.address",
                        },
                        model: {
                          value: _vm.tempAddressData.shippingAddress,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tempAddressData,
                              "shippingAddress",
                              $$v
                            )
                          },
                          expression: "tempAddressData.shippingAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "md-datepicker",
                        {
                          ref: "mdDatePicker",
                          attrs: { "md-immediately": "", "md-debounce": 10 },
                          model: {
                            value: _vm.orderDetails.expectedDeliveryDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.orderDetails,
                                "expectedDeliveryDate",
                                $$v
                              )
                            },
                            expression: "orderDetails.expectedDeliveryDate",
                          },
                        },
                        [
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "left" } },
                            [
                              _vm._v(
                                "\n                            The delivery date refers to the scheduled date for a stop once the delivery is\n                            confirmed.\n                        "
                              ),
                            ]
                          ),
                          _c("label", [_vm._v("Delivery Date")]),
                        ],
                        1
                      ),
                      _vm.isDropStopAssigned
                        ? _c(
                            "div",
                            { staticClass: "md-helper-text-datepicker" },
                            [
                              _vm._v(
                                "\n                        This delivery is already assigned to a team member. Updating the expected delivery date will impact the team member's trip.\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "md-datepicker",
                        {
                          ref: "mdDatePicker",
                          attrs: { "md-immediately": "", "md-debounce": 10 },
                          model: {
                            value: _vm.orderDetails.readyPickupAvailableDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.orderDetails,
                                "readyPickupAvailableDate",
                                $$v
                              )
                            },
                            expression: "orderDetails.readyPickupAvailableDate",
                          },
                        },
                        [
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "left" } },
                            [
                              _vm._v(
                                "\n                            The ready pickup date refers to the scheduled date for a stop once the package is ready\n                            to be picked up.\n                        "
                              ),
                            ]
                          ),
                          _c("label", [_vm._v("Ready Pickup Date")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "md-datepicker",
                        {
                          ref: "mdDatePicker",
                          attrs: { "md-immediately": "", "md-debounce": 10 },
                          model: {
                            value: _vm.orderDetails.readyDeliveryAvailableDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.orderDetails,
                                "readyDeliveryAvailableDate",
                                $$v
                              )
                            },
                            expression:
                              "orderDetails.readyDeliveryAvailableDate",
                          },
                        },
                        [
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "left" } },
                            [
                              _vm._v(
                                "\n                            The ready delivery date is the earliest available date the recipient can schedule this\n                            order for delivery.\n                        "
                              ),
                            ]
                          ),
                          _c("label", [_vm._v("Ready Delivery Date")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "loader-container" },
                  [
                    _c("fade-loader", {
                      attrs: { loading: true, color: "#333333" },
                    }),
                    _c("span", [_vm._v("LOADING")]),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          !_vm.isLoading
            ? _c(
                "md-button",
                {
                  staticClass: "dialog-button md-primary",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.updateOrder($event)
                    },
                  },
                },
                [_vm._v("\n                Update\n            ")]
              )
            : _vm._e(),
          _c(
            "md-button",
            {
              staticClass: "dialog-button md-default",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$modal.hide($event)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }